<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="goScheduleNotificationForm" type="default">추가</base-button>
            <base-button @click="setVisibleOrder" type="default">노출순서 변경</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-1">아이디</div>
      <div class="col-sm-2">알림명</div>
      <div class="col-sm-2">알림라벨</div>
      <div class="col-sm-2">제목</div>
      <div class="col-sm-2">내용</div>
      <div class="col-sm-1">기준시간</div>
      <div class="col-sm-1">상세설정</div>
      <div class="col-sm-1">삭제</div>
    </div>
    <hr />
    <draggable handle=".handle" v-model="data" @start="drag = true" @end="drag = false">
      <div class="row handle" v-for="(item, index) in data">
        <div class="col-sm-1">{{ item.id }}</div>
        <div class="col-sm-2">{{ item.name }}</div>
        <div class="col-sm-2">{{ item.analyticsLabel }}</div>
        <div class="col-sm-2">{{ item.title }}</div>
        <div class="col-sm-2">{{ item.body }}</div>
        <div class="col-sm-1">{{ item.interval }}</div>
        <div class="col-sm-1">
          <base-button @click.native="goNotificationTypeForm(item.id)" type="warning" size="sm" icon>
            <i class="tim-icons icon-pin" />
          </base-button>
        </div>
        <div class="col-sm-1">
          <base-button @click.native="removeNotificationType(item, index)" type="warning" size="sm" icon>
            <i class="tim-icons icon-simple-delete" />
          </base-button>
        </div>
      </div>
    </draggable>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPageAll" :pageCount="totalPagesAll" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BaseInput, BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";
import { URLUtils } from "@/util/URLUtils";
import swal from "sweetalert2";
import draggable from "vuedraggable";

export default {
  components: {
    BaseInput,
    draggable,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    await this.getData(1);
  },
  data() {
    return {
      data: [],
      currentPageAll: 1,
      totalPagesAll: null,
    };
  },
  methods: {
    async getData(page) {
      const queryParams = {
        artistName: this.artistName,
      };
      this.currentPageAll = page;
      this.currentPageMerge = page;
      const params = { name: this.artistName };
      params.currentPage = page ? page : 1;
      this.spanArr = [];

      const path = `/schedules/scheduleNotificationType?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      await this.$axios.get("/schedule/scheduleNotificationTypes", { params }).then((res) => {
        this.data = res.data.data.map((d) => {
          d.regDate = formatDateTime(d.regTime, "YYYY-MM-DD");
          d.timeInterval = d.timeInterval === 0 ? "" : d.timeInterval + "분";
          d.interval = d.timeStandard === 1 ? `시작시간 기준 ${d.timeInterval}` : `종료시간 기준 ${d.timeInterval}`;
          return d;
        });
        this.totalPagesAll = Number(res.data.data.page);
        this.searchedFilter = this.filterType;
      });
    },
    async goNotificationTypeForm(id) {
      await this.$router.push(`/schedules/scheduleNotificationTypeForm?id=${id}`);
    },
    async removeNotificationType(row, index) {
      if (row.id) {
        swal
          .fire({
            title: "삭제 확인",
            text: `${row.name} 알림타입을 삭제하시겠습니까?`,
            type: "warning",
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-danger btn-fill",
              cancelButton: "btn btn-cancel btn-fill",
            },
            confirmButtonText: "삭제",
            cancelButtonText: "취소",
            buttonsStyling: false,
          })
          .then(async (selection) => {
            if (selection.value) {
              return this.$axios.delete(`/schedule/scheduleNotificationTypes/${row.id}`).then((res) => {
                window.Toast.success("삭제되었습니다");
                this.getData();
              });
            }
          });
      } else {
        this.data.splice(index, 1);
      }
    },

    async goScheduleNotificationForm() {
      this.$router.push(`/schedules/scheduleNotificationTypeForm`);
    },
    async setVisibleOrder() {
      const types = [];
      this.data.forEach((item, order) => {
        types.push({ id: item.id, order });
      });
      return this.$axios.put("/schedule/notificationTypeOrder", { types }).then((res) => {
        Toast.success("노출순서가 변경되었습니다");
        this.getData();
      });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
